/* eslint-disable react/destructuring-assignment */

import * as React from 'react';
import { ParticipantVirtualGraduationState } from 'stageclip-common';

import styles from './participantsState.module.scss';

interface ParticipantsVirtualGraduationStateProps {
  state: any;
}

export class ParticipantsVirtualGraduationState extends React.Component<ParticipantsVirtualGraduationStateProps> {
  private static renderState(value: string, className: string) {
    return <span className={className}>{value}</span>;
  }

  private static getStateCell(state: ParticipantVirtualGraduationState) {
    switch (state) {
      case ParticipantVirtualGraduationState.Invited:
        return ParticipantsVirtualGraduationState.renderState('Invited', styles.processingState);
      case ParticipantVirtualGraduationState.Submitted:
        return ParticipantsVirtualGraduationState.renderState('Submitted', styles.processedState);
      case ParticipantVirtualGraduationState.Accepted:
        return ParticipantsVirtualGraduationState.renderState('Accepted', styles.readyToGenerateState);
      case ParticipantVirtualGraduationState.Rejected:
        return ParticipantsVirtualGraduationState.renderState('Rejected', styles.errorState);
      case ParticipantVirtualGraduationState.New:
      default:
        return ParticipantsVirtualGraduationState.renderState('New', styles.newState);
    }
  }

  public render() {
    return ParticipantsVirtualGraduationState.getStateCell(this.props.state);
  }
}
